export function Flap3D({ open, height, width }: any) {
    return (
        <svg width={width || '100%'} height={height || '100%'} viewBox="0 0 100 100">
            <path id="damper_frameBottom" d="M 80,70 L70,70 L40,100 L50,100" fill="#C0C0C0"></path>
            <path id="damper_frameBack" d="M 80,70 L70,70 L70,10 L80,0" fill="#A0A0A0"></path>
            {!open && (
                <g id="damperClosedRibs">
                    <path d="M 77,64 L74,56 L44,88 L47,94 Z" fill="#C0C0C0" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,54 L74,46 L44,77 L47,84 Z" fill="#C0C0C0" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,44 L74,36 L44,67 L47,74 Z" fill="#C0C0C0" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,34 L74,26 L44,57 L47,64 Z" fill="#C0C0C0" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,24 L74,16 L44,47 L47,54 Z" fill="#C0C0C0" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,14 L74,06 L44,37 L47,44 Z" fill="#C0C0C0" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                </g>
            )}
             {open && (
                <g id="damperOpenRibs">
                    <path d="M 77,64 L74,56 L44,88 L47,94 Z" fill="transparent" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,54 L74,46 L44,77 L47,84 Z" fill="transparent" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,44 L74,36 L44,67 L47,74 Z" fill="transparent" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,34 L74,26 L44,57 L47,64 Z" fill="transparent" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,24 L74,16 L44,47 L47,54 Z" fill="transparent" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                    <path d="M 77,14 L74,06 L44,37 L47,44 Z" fill="transparent" strokeWidth="2" stroke="#B0B0B0" strokeLinejoin='round'></path>
                </g>
            )}
            <path id="damper_frameTop" d="M 70,0 L40,30 L50,30 L80,0" fill="#C0C0C0"></path>
            <path id="damper_frameFront" d="M 40,30 L40,100 L50,100 L50,30" fill="#A0A0A0"></path>
        </svg>
    );
}